import { FormControl, Icon } from '@chakra-ui/react';
import { FolderSearchIcon } from 'lucide-react';
import { FC } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';
import { SearchInput } from '~/common/components/Inputs/SearchInput';

interface SearchFilterProps {
  placeholder?: string;
}

export const SearchFilter: FC<SearchFilterProps> = ({
  placeholder = 'Search folders',
}) => {
  const { setSearchTerm, searchTerm } = useOrganizationCompliancePage();

  return (
    <FormControl>
      <SearchInput
        defaultValue={searchTerm}
        leftIcon={<Icon as={FolderSearchIcon} color="purple.500" />}
        placeholder={placeholder}
        w="200px"
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </FormControl>
  );
};
